// extracted by mini-css-extract-plugin
module.exports = {"innerFlex":"Vehicle_innerFlex__1HFVH","categories":"Vehicle_categories__quIeT"};